
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getPromoteInfo } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
info: {}
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
getPromoteInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
}



// WEBPACK FOOTER //
// ./src/pages/promote.vue